import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';

const TeaserFooter = () => {
  return (
    <>
      {/* Sticky Footer Bar */}
      <motion.div
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
        className="fixed bottom-0 left-0 right-0 z-30 bg-[#082BCC] text-white py-4 shadow-2xl"
        data-testid="teaser-footer-sticky"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Calendar className="w-5 h-5" />
            <p className="font-satoshi font-medium text-sm sm:text-base">
              RenAIssance 2027 is coming — be the first to know.
            </p>
          </div>
          <a
            href="https://lu.ma/renaissance27"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 bg-white text-[#082BCC] font-satoshi font-bold px-6 py-2 rounded-lg hover:bg-[#F5F5F5] transition-all hover:shadow-lg"
            data-testid="teaser-footer-cta"
          >
            <span className="hidden sm:inline">Register Interest</span>
            <span className="sm:hidden">Register</span>
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </a>
        </div>
      </motion.div>

      {/* End Section */}
      <motion.section
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative bg-[#1A1A1A] text-white py-24 overflow-hidden"
        data-testid="teaser-footer-section"
      >
        {/* Background decoration */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[#082BCC]/10 blur-3xl" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            <p className="font-satoshi font-bold text-sm tracking-widest uppercase text-[#082BCC] mb-6" data-testid="teaser-footer-label">
              See You Next Year
            </p>
            
            <h2 className="font-satoshi font-black text-5xl md:text-7xl tracking-tight leading-none mb-6" data-testid="teaser-footer-heading">
              The conversation<br />doesn't end here.
            </h2>
            
            <p className="font-satoshi font-medium text-xl md:text-2xl text-white/70 mb-12" data-testid="teaser-footer-subheading">
              RenAIssance 2027 — coming soon.
            </p>
            
            <a
              href="https://lu.ma/renaissance27"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-3 bg-[#082BCC] text-white font-satoshi font-bold text-lg px-10 py-5 rounded-xl hover:bg-[#0624a3] transition-all hover:shadow-2xl hover:shadow-[#082BCC]/30"
              data-testid="teaser-footer-main-cta"
            >
              Secure your spot
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </a>
          </motion.div>
        </div>
      </motion.section>
    </>
  );
};

export default TeaserFooter;